import React from "react";
import { Modal, Form } from "react-bootstrap";
import API from "../services/api";
import { GroupContext } from "../services/contexts/GroupContext";
import MultiSelect from "./common/MultiSelect";
import classes from "./CreateAccount.module.css";
import CustomButton from "./common/CustomButton";
import toast from "react-hot-toast";

export default function CreateAccount() {
  const { globalData, getLatestData } = React.useContext(GroupContext);
  const [selectedGroups, setSelectedGroup] = React.useState([]);

  const [isOpen, setIsOpen] = React.useState(false);
  const [userState, setUserState] = React.useState({
    first_name: "",
    last_name: "",
    username: "",
    confirm_username: "",
    sendWelcomeEmail: false,
  });
  const formDataInvalid = () => {
    return (
      userState.first_name.length === 0 ||
      userState.last_name.length === 0 ||
      userState.username.length === 0 ||
      userState.confirm_username.length === 0 ||
      (userState.username.length > 0 &&
        userState.confirm_username.length > 0 &&
        userState.confirm_username !== userState.username)
    );
  };
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    setUserState({
      first_name: "",
      last_name: "",
      username: "",
      confirm_username: "",
      sendWelcomeEmail: false,
    });
    setSelectedGroup([]);
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    API.post("admin/register", {
      username: userState.username,
      firstName: userState.first_name,
      lastName: userState.last_name,
      sendWelcomeEmail: userState.sendWelcomeEmail,
      allowed_groups: selectedGroups.map((group) => group.group_id),
    })
      .then(async (res) => {
        alert(res.data.msg);
        await getLatestData();
        handleClose();
      })
      .catch((e) => {
        alert(e.response.data.msg);
      });
  };

  return (
    <>
      <CustomButton
        variant="outline-primary"
        onClick={handleOpen}
        className={classes.create_button}
      >
        Add New
      </CustomButton>
      <Modal
        show={isOpen}
        onHide={handleClose}
        dialogClassName={classes.create_modal_dialog}
        backdropClassName={classes.create_modal_backdrop}
        contentClassName={classes.create_modal_content}
        backdrop="static"
      >
        <Modal.Header className="_g-modal-header_">
          <div className="_g-close-button-anchor_">
            <div className="_g-close-button_" onClick={handleClose}>
              &#x2715;
            </div>
          </div>
          Create New User
        </Modal.Header>

        <Modal.Body className={`_g-modal-body_ ${classes.create_modal_body}`}>
          <Form
            onSubmit={(e) => onFormSubmit(e)}
            style={{
              display: "flex",
              gap: "15px",
              flexDirection: "column",
              margin: "15px 0",
            }}
          >
            <Form.Group>
              <Form.Label>
                First Name <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                maxLength={45}
                value={userState.first_name}
                onChange={(e) => {
                  setUserState((prev) => ({
                    ...prev,
                    first_name: e.target.value,
                  }));
                  if (e.target.value.length === 45) {
                    toast.error(
                      `First name can not be longer than 45 characters.`
                    );
                  }
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Last Name <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                maxLength={45}
                value={userState.last_name}
                onChange={(e) => {
                  setUserState((prev) => ({
                    ...prev,
                    last_name: e.target.value,
                  }));
                  if (e.target.value.length === 45) {
                    toast.error(
                      `Last name can not be longer than 45 characters.`
                    );
                  }
                }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                Username / Email <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                required
                type="email"
                maxLength={45}
                value={userState.username}
                onChange={(e) => {
                  setUserState((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }));
                  if (e.target.value.length === 45) {
                    toast.error(
                      `Email can not be longer than 45 characters.`
                    );
                  }
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Confirm Username / Email <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                required
                type={"email"}
                maxLength={45}
                value={userState.confirm_username}
                onChange={(e) => {
                  setUserState((prev) => ({
                    ...prev,
                    confirm_username: e.target.value,
                  }));
                }}
              />
            </Form.Group>
            {userState.username !== userState.confirm_username && (
              <div className={classes["error-feedback"]}>
                Both username must match.
              </div>
            )}
            <Form.Group>
              <div className={classes.sendWelcomeEmail}>
                <input
                  className={classes.checkbox}
                  checked={userState.sendWelcomeEmail}
                  type="checkbox"
                  onChange={() => {
                    setUserState((prev) => ({
                      ...prev,
                      sendWelcomeEmail: !prev.sendWelcomeEmail,
                    }));
                  }}
                />
                <span>Send Welcome Email </span>
              </div>
            </Form.Group>

            <MultiSelect
              label="Assign group"
              options={globalData.allGroups}
              selected={selectedGroups}
              onChange={setSelectedGroup}
              placeholder="Please Select"
              className={classes.group_select}
            />
            <div className="_g-modal-button-wrapper_">
              <CustomButton variant="outline-secondary" onClick={handleClose}>
                Cancel
              </CustomButton>
              <CustomButton disabled={formDataInvalid()} type="submit">
                Submit
              </CustomButton>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
